import axios from 'axios';

export const callEndpoint = async (postData, postUrl, action) => {
  try {
    // Construct the full API URL
    const api_url = 'https://admin.tickleright.in/routes/'; // Replace with your actual base URL
    const fullUrl = api_url + postUrl;

    var Body = JSON.stringify({
      ...postData, // Include existing data
      form_token: "ABCD12345678", // Add the new key-value pair
  });

    const finalHeaders = {
    //   "form_token": "ABCD12345678"
    };

    // Construct action type
    const action_type = { action };

    // Make the POST request using axios
    const response = await axios.post(fullUrl, Body, {
      headers: finalHeaders,
      params: action_type,
    });

    // Return the response data
    return response.data;
  } catch (error) {
    console.error('Error in API call:', error);
    throw error;
  }
};